
import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import './Grant.css'; // Import the CSS file
import Navbar from '../../Components/Navbar';
import Navbar2 from '../../Components/Navbar2';
import Sidebar from '../../Components/Sidebar';
import { useNavigate } from 'react-router-dom';
import { useForm } from './MainForm'; // Import useForm from your context
import axios from 'axios';
import { API_BASE_URL } from '../../config';

export default function Grant() {
  const { formData, handleFormDataChange, updateCompletionStatus , resetFormData } = useForm(); // Use form context
  const [submitted, setSubmitted] = useState(false); // Define state for form submission
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formErrors, setFormErrors] = useState({}); // Define state for form errors
  const navigate = useNavigate();
  
  const [coInvestigators, setCoInvestigators] = useState(
    formData.co_investigators || [{ name: '', departmentUniversity: '' }] // Load data from formData or set default
  );

  useEffect(() => {
    // Load existing co-investigators from formData when the component mounts
    if (formData.co_investigators) {
      setCoInvestigators(formData.co_investigators);
    }
  }, [formData.co_investigators]);

  const handleChange = (index, event) => {
    const { name, value } = event.target;
    const newCoInvestigators = [...coInvestigators];
    newCoInvestigators[index][name] = value;
    setCoInvestigators(newCoInvestigators); // Update co-investigators state
    handleFormDataChange({ co_investigators: newCoInvestigators }); // Also update the central form data
  };

  // Handle foreign collaborators field change
  const handleForeignChange = (event) => {
    const { name, value } = event.target;
    handleFormDataChange({ [name]: value }); // Update formData for foreign collaborators
  };

  const validate = () => {
    let errors = {};
    // Validation for co-investigators
    if (!coInvestigators[0].name) errors.co_investigators = 'Co-investigators are required.';
    if (!coInvestigators[0].departmentUniversity) 
      errors.co_investigator_departmentUniversity = 'Affiliated Department and University are required.';

   

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Handle adding new row
  const handleAddRow = () => {
    const newRow = { name: '', departmentUniversity: '' };
    setCoInvestigators([...coInvestigators, newRow]);
  };

  // Handle removing a row
  const handleRemoveRow = (index) => {
    const newCoInvestigators = [...coInvestigators];
    newCoInvestigators.splice(index, 1);
    setCoInvestigators(newCoInvestigators);
  };

 
  const handleSubmit = async () => {
    if (validate()) {
      try {
        // First: Submit data to Grant.php
        const grantResponse = await axios.post(`${API_BASE_URL}/Grant.php`, formData, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          transformRequest: [(data) => {
            const params = new URLSearchParams();
            for (const key in data) {
              params.append(key, data[key]);
            }
            return params;
          }],
        });
  
        alert(grantResponse.data.message); // Display response message from Grant.php
  
        // Prepare relevantData for MultipleRows.php
        const relevantData = {
          coInvestigators: coInvestigators, // Include coInvestigators data
        };
  
        // Second: Send filtered data to MultipleRows.php with 'application/json'
        const multipleRowsResponse = await axios.post(`${API_BASE_URL}/MultipleRows.php`, relevantData, {
          headers: {
            'Content-Type': 'application/json', // Use JSON for sending data
          },
        });
  
        alert(multipleRowsResponse.data.message); // Display response message from MultipleRows.php
        setSubmitted(true); // Set form as submitted
  
      } catch (error) {
        alert('There was an error submitting the form. Please try again.');
      }
    }
  };
  
  const handleSave = async () => {
    if (isSubmitted) {
      alert('Form data has already been saved.');
      return; // Prevent further submissions
    }
  
    try {
      // Step 1: Save the form data
      const response = await axios.post(`${API_BASE_URL}/SaveForm.php`, formData, {
        headers: {
          'Content-Type': 'application/json',
        },
        transformRequest: [(data) => {
          const params = new URLSearchParams();
          for (const key in data) {
            params.append(key, data[key]);
          }
          return params;
        }],
      });
  
      if (response.data.status === 'success') {
        setIsSubmitted(true);
        alert('Form saved successfully.');
  
        // Step 2: Upload the files
        const fileUploadResponse = await axios.post(`${API_BASE_URL}/SaveFileUploads.php`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
  
        console.log(fileUploadResponse.data); 
  
        if (fileUploadResponse.data.status === 'success') {
          alert('Files uploaded successfully.');
  
          // Step 3: Filter out relevant data for MultipleRows.php
          const relevantData = {
            grantRows: formData.grantRows,
            fundingRows: formData.fundingRows,
            co_investigators: formData.co_investigators, // Add the multiple rows for supervisors here
          };
  
          // Step 4: Submit the filtered data to MultipleRows.php
          const multipleRowsResponse = await axios.post(`${API_BASE_URL}/SaveMultipleRows.php`, relevantData, {
            headers: {
              'Content-Type': 'application/json', // Set content type to JSON for MultipleRows.php
            },
          });
  
          console.log(multipleRowsResponse.data); // Log the response for debugging
  
          if (multipleRowsResponse.data.status === "success") {
            localStorage.removeItem('formData');
            resetFormData();
            navigate('/submittedgrant'); // Navigate to the submitted grant page
          } else {
            alert('Submission to MultipleRows.php failed: ' + multipleRowsResponse.data.message);
          }
        } else {
          alert(fileUploadResponse.data.message);
        }
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      console.error('Error details:', error);
      alert('There was an error saving the data or uploading files. Please try again.');
    }
  };


  // function to navigate to next page
  const handleNext = async () => {
    if (validate()) {
      updateCompletionStatus('supervisors', true);
      navigate('/uploads'); // Navigate to the uploads page
    } else {
      alert('Missing Fields Required.');
    }
  };

  // function to navigate to previous page
  const handlePrevious = () => {
    navigate('/project'); // Navigate to the project page
  };

  return (
    <div>
      <Navbar />
      <Navbar2 />
      <Sidebar />
      
      <div className="form-container">
        
        <Form onSubmit={handleSubmit}>
          <Row className="mb-3">
            {coInvestigators.map((investigator, index) => (
              <div key={index}>
                <Form.Group controlId={`formGridInvestigator${index}`}>
                  <Form.Label>
                    1. Co-investigator {index + 1} <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    name="name"
                    value={investigator.name}
                    onChange={(e) => handleChange(index, e)}
                    placeholder="Enter co-investigator's name"
                    isInvalid={!!formErrors.co_investigators}
                  />
                  <Form.Control.Feedback type="invalid">
                    {formErrors.co_investigators}
                  </Form.Control.Feedback>

                  <Form.Label>
                  Affiliated Department and University (200 Characters Only)  <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                  name="departmentUniversity"
                  value={investigator.departmentUniversity}
                  onChange={(e) => handleChange(index, e)}
                  placeholder="Enter affiliated Department and University"
                  isInvalid={!!formErrors.co_investigator_departmentUniversity}
                  maxLength={200} // Limit characters to 200
                />
                  <Form.Control.Feedback type="invalid">
                    {formErrors.co_investigator_departmentUniversity}
                  </Form.Control.Feedback>
                  <div className="text-muted" style={{ fontSize: '0.875rem' }}>
                    {investigator.departmentUniversity ? investigator.departmentUniversity.length : 0} / 200
                  </div>


                  {coInvestigators.length > 1 && (
                    <Button variant="secondary" size="sm" onClick={() => handleRemoveRow(index)} className="mb-3">
                      Remove
                    </Button>
                  )}
                </Form.Group>
              </div>
            ))}
          </Row>


          <Button variant="secondary" size="sm" onClick={handleAddRow} className="mb-3">
            Add Row
          </Button>

          <Form.Group controlId="formGridforeign">
            <Form.Label>2. Foreign Collaborators of the Project </Form.Label>              
            <Form.Control
              name="foreign_collaborators"
              value={formData.foreign_collaborators || ''}
              onChange={handleForeignChange}
              placeholder="Enter foreign collaborator's Name"
              //isInvalid={!!formErrors.foreign_collaborators}
            />
            <Form.Control.Feedback type="invalid">
              {formErrors.foreign_collaborators}
            </Form.Control.Feedback>

            <Form.Label>Affiliated Department and University (200 Characters Only) </Form.Label>
            <Form.Control
            name="foreign_collaborator_departmentUniversity"
            value={formData.foreign_collaborator_departmentUniversity || ''}
            onChange={handleForeignChange}
            placeholder="Enter affiliated Department and University"
            isInvalid={!!formErrors.foreign_collaborator_departmentUniversity}
            maxLength={200} // Limit characters to 200
            />
            <Form.Control.Feedback type="invalid">
            {formErrors.foreign_collaborator_departmentUniversity}
            </Form.Control.Feedback>
            <div className="text-muted" style={{ fontSize: '0.875rem' }}>
            {formData.foreign_collaborator_departmentUniversity
            ? formData.foreign_collaborator_departmentUniversity.length
          : 0} / 200
          </div>

          </Form.Group>

          {/* <Button variant="primary" type="button" onClick={handleSave} className='savebutton'>
            Save
          </Button> */}
          <Button variant="primary" type="button" onClick={handlePrevious} className='previousbutton'>
            Previous
          </Button>
          <Button variant="primary" type="button" onClick={handleNext} className='nextbutton'>
            Next
          </Button>
        </Form>
      </div>
    </div>
  );
}
